/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */
import AnalyticsWebClient from './analyticsWebClient';
import {
	aliasType,
	apdexType,
	envType,
	eventType,
	groupType,
	originTracingType,
	originType,
	perimeterType,
	platformType,
	productEmbedType,
	tenantType,
	userType,
} from './analyticsWebTypes';
import DwellTimeHelper from './dwellTimeHelper';
import DwellTimeHelperWithBrowserInteraction from './DwellTimeHelperWithBrowserInteraction';
import { CompressionRule } from './eventDelay/compressionRule';
import { StopLowPriorityEventDelayReason } from './eventDelay/types';
import { ResilienceMechanism } from './resilienceQueue';
import { STARGATE_PROXY_PATH } from './selectHost';
import TypeAheadHelper from './typeAheadHelper';

/**
 * @deprecated Import directly from `./types` instead of this re-export.
 */
export type {
	OperationalEventPayload,
	ProductInfoType,
	ScreenEventPayload,
	SettingsType,
	TrackEventPayload,
	UIEventPayload,
} from './types';

/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export {
	AnalyticsWebClient as default,
	apdexType,
	envType,
	eventType,
	originType,
	platformType,
	tenantType,
	userType,
	originTracingType,
	// Helpers
	TypeAheadHelper,
	DwellTimeHelper,
	DwellTimeHelperWithBrowserInteraction,
	CompressionRule,
	ResilienceMechanism,
	StopLowPriorityEventDelayReason,
	STARGATE_PROXY_PATH,
	perimeterType,
	aliasType,
	groupType,
	productEmbedType,
};
